import { Grid } from '@mui/material';
import ProductCatalogHeader from './Header/ProductCatalogHeader';
import { ProductCatalogDesktopRecentlyViewedSection, ProductCatalogMobileRecentlyViewedSection } from './RecentlyViewed/ProductCatalogRecentlyViewedSections';
import ProductCatalogResults from './Results/ProductCatalogResults';
import ProductCatalogToolbar from './Toolbar/ProductCatalogToolbar';

export default function ProductCatalogList() {
  return <>
    <Grid container spacing={{xs: 1, md: 2, lg: 3}}>
      <Grid item xs={12}>
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs>
            <ProductCatalogHeader />
          </Grid>
        </Grid>
      </Grid>
      <ProductCatalogDesktopRecentlyViewedSection />
      <ProductCatalogMobileRecentlyViewedSection />
      <ProductCatalogToolbar />
      <ProductCatalogResults />
    </Grid>
  </>
}
